import React from "react";
import { motion } from "framer-motion";

// Definir las categorías basadas en los servicios
const serviceCategories = [
  { id: "all", name: "Todos los Servicios" },
  { id: "consultoria", name: "Consultoría" },
  { id: "desarrollo", name: "Desarrollo" },
  { id: "marketing", name: "Marketing" },
  { id: "diseño", name: "Diseño" },
  { id: "seo", name: "SEO" },
  { id: "video", name: "Video" }
];

const CategoryFilter = ({ selectedCategory, onCategoryChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="flex flex-wrap justify-center gap-3 mb-12"
    >
      {serviceCategories.map((category) => (
        <motion.button
          key={category.id}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
            selectedCategory === category.id
              ? "bg-gradient-to-r from-teal-600 to-blue-600 text-white shadow-lg"
              : "bg-white text-gray-700 hover:bg-gray-50 shadow-sm border border-gray-100"
          }`}
        >
          {category.name}
        </motion.button>
      ))}
    </motion.div>
  );
};

export default CategoryFilter;